export default {
  computed: {
    activeTab () {
      return this.tabsData.find(tab => tab[2] === true)[0]
    },
    tabThirdMenu () {
      return {
        fv: [
          {
            event: { name: `${this.service}:main:addInvoice` },
            icon: 'plus',
            label: 'Dodaj fakturę',
            acl: { service: this.service, action: 'put_invoice' }
          },
          {
            event: { name: `${this.service}:main:deleteInvoice` },
            icon: 'minus',
            label: 'Usuń fakturę',
            acl: { service: this.service, action: 'delete_invoices' }
          }
        ],
        subtasks: this.subtasksCondition,
        payments: this.paymentsCondition,
        formularz: this.formButtons,
        fokusIframeNew: this.fokusIframeNewButtons,
        fokusIframeOld: this.fokusIframeOldButtons
      }
    },
    subtasksCondition () {
      if (this.task && this.task.id !== 0 && this.task.state && !this.task.state.initial) {
        return [
          {
            event: { name: `${this.service}:main:addAppraisalTask` },
            icon: 'plus',
            label: 'Dodaj podzlecenie',
            acl: { service: this.service, action: this.$isWithClients(this.service) ? `post_task__create-appraisal__${this.$route.meta.client}` : 'post_appraisal_task' }
          }
        ]
      }
    },
    paymentsCondition () {
      if (this.task && this.task.id !== 0 && this.task.state && !this.task.state.initial) {
        return [
          {
            event: { name: `${this.service}:main:addPaymentTask` },
            icon: 'plus',
            label: 'Dodaj wypłatę'
            // TODO: add proper ACL action name
            // acl: {service: 'intgen', action: 'put_main_task'}
          }
        ]
      }
    },
    generateDocumentConditions () {
      if (this.task && this.task.state && !this.task.state.initial) {
        return [
          {
            event: { name: `${this.service}:main:openGenerateDocumentModal` },
            icon: 'filepdf',
            label: 'Generuj pismo',
            acl: { service: this.service, action: 'post_document' }
          }
        ]
      }
    },
    fokusIframeNewButtons () {
      if (this.task && this.task.state && !this.task.state.initial && !this.task.state.final) {
        if (this.taskType === 'appraisal' && ['intgen','intbls','intvhs'].includes(this.service)) {
          return [
            {
              event: { name: `${this.service}:appraisal:sendFocusSmsNew` },
              icon: 'send',
              label: 'menu.main.taskDetails.fokussms',
              acl: { service: this.service, action: 'post_focus_sms_new' }
            }
          ]
        } else {
          return [
            {
              event: { name: `${this.service}:main:sendFocusSmsNew` },
              icon: 'send',
              label: 'menu.main.taskDetails.fokussms',
              acl: { service: this.service, action: 'post_focus_sms_new' }
            }
          ]
        }
      }

      return []
    },
    fokusIframeOldButtons () {
      if (this.task && this.task.state && !this.task.state.initial && !this.task.state.final) {
        if (this.taskType === 'appraisal' && ['intgen','intbls','intvhs'].includes(this.service)) {
          return [
            {
              event: { name: `${this.service}:appraisal:sendFocusSms` },
              icon: 'send',
              label: 'menu.main.taskDetails.fokussms',
              acl: { service: this.service, action: 'post_focus_sms' }
            }
          ]
        } else {
          return [
            {
              event: { name: `${this.service}:main:sendFocusSms` },
              icon: 'send',
              label: 'menu.main.taskDetails.fokussms',
              acl: { service: this.service, action: 'post_focus_sms' }
            }
          ]
        }
      }

      return []
    },
    cloneTaskConditions () {
      return [
        {
          event: { name: `${this.service}:main:cloneTask` },
          icon: 'copy',
          label: 'Kopiuj zlecenie',
          acl: { service: this.service, action: this.$isWithClients(this.service) ? `post_task__copy__${this.$route.meta.client}` : `post_${this.workflowName}_task_copy` }
        }
      ]
    },
    formButtons () {
      let buttons = [this.generateDocumentConditions, this.cloneTaskConditions]
      return buttons.filter(element => element).map(button => button[0])
    }
  }
}
